export default {"src":"/_next/static/media/ticket.ee45123b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};